import { OrganizationConfig } from 'services/organization/type';

export const getDefaultCustomRequest = (
  organizationConfig: OrganizationConfig | null
) => {
  if (organizationConfig?.customRequest) {
    return organizationConfig.customRequest;
  }
  return "Thank you for providing that information. We'll get back to you shortly.";
};
